<template>
  <div>
    <van-popup closeable get-container="body" v-model="printVisble" :close-on-click-overlay="false" position="bottom" round>
      <div class="printModle">
       <h2 class="info"><img src="../../../assets/order/tabber_icon@2x.png" alt=""><span>寄件人信息</span></h2>
        <div class="d1">
          <van-form>
            <van-field
            v-model="form.shipperName"
            label="寄件人"
            placeholder="姓名"
          />
          <van-field 
            class="mt10"
            type="tel"
            v-model="form.shipperMobile"
            label="寄件人电话"
            placeholder="手机号"
          />
          <div class="hed_piao">
            <van-field
              class="mt10"
              readonly
              clickable
              :value="areaName"
              label="寄送地址"
              placeholder="选择省/市/区"
              @click="showArea = true"
            />
            <van-icon class="piao" name="arrow" size="11" color="#999999"/>
          </div>
          <van-field
            class="mt10"
            type="textarea"
            rows="1"
            autosize
            v-model="form.addressDetail"
            label="  "
            placeholder="街道门牌、楼层房间号等信息"
          />
          </van-form>
          
        </div>
        <div v-if="!this.isPrintAll">
          <h2 class="info"><img src="../../../assets/order/tabber_icon@2x.png" alt=""><span>收件人信息</span></h2>
          <div class="d2">
            <div class="recive-img">
              <img src="../../../assets/order/icon_add_new@2x.png" />
            </div>
            <div class="recive-message">
              <div class="recive-phone"><span>{{form.reciveName}}</span>  <span>{{form.reciveMobile}}</span></div>
              <div class="recive-address">{{form.reciveAddress}}</div>
            </div>
            <!-- <van-field
              readonly
              class="mt10"
              v-model="form.reciveName"
              label="收件人："
            />
            <van-field
              readonly
              class="mt10"
              v-model="form.reciveMobile"
              label="收件人电话："
            />
            <van-field
              type="textarea"
              readonly
              class="mt10"
              v-model="form.reciveAddress"
              label="收件地址："
            /> -->
          </div>
        </div>
        <div v-if="this.printType == '2'">
          <h2 class="info">一键打印拣货单</h2>
          <div class="d3 d3-1">
            <van-field
              readonly
              class="mt10"
              :value="this.isPrintAll == 0 ? '1' : form.enablePrintCount"
              label="总共可打印订单拣货单 ："
            />
            <span class="dan">个</span>
          </div>
          <div class="d3 d3-2" v-if="isPrintAll == '1'">
            <van-field
              readonly
              class="mt10"
              :value="form.disablePringCount"
              label="已备注订单暂不能批量操作打印："
            />
            <span class="dan">个</span>
          </div>
        </div>
      </div>
      <div class="printFooter">
        <div class="d0">
          <!-- <div class="d1" @click="printVisble = false">取消</div> -->
          <div class="d2">
            <van-button
              @click="checkInputFun"
              :loading="loading"
            >确定
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showArea" position="bottom" get-container="body">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import AreaList from "@/utils/area.js";
export default {
  name: '',
  props: {
  },
  data() {
    return {
      printVisble: false,
      form:{
        addressDetail: '',
        areaId: '',
        areaName: '',
        cityId: '',
        cityName: '',
        provinceId: '',
        provinceName: '',
        shipperMobile: '',
        shipperName: '',
        reciveName:'',
        reciveMobile:'',
        reciveAddress:'',
        enablePrintCount:'',
        disablePringCount:''
      },
      showArea:false,
      areaList: AreaList,
      areaName:'',
      loading:false,
      currSubOrderId:'',
      printType:'',
      isPrintAll:'',
      deliveryType:{
        '0': '1', //快递码-快递发货
        '1': '1', //快递吗-自行发货
        '2': '2' //拣货方式
      },
      orderStatusQuery:'',
      orderTypeQuery:'',
      filterRow:{
        "branchRemarkType": '',
        "endTime": "",
        "searchKey": "",
        "startTime": ""
      },
      subOrderIdVO:[]
    }
  },
  methods: {
    getPowerFun(item, printType, isPrintAll='', filterRow = {},subOrderIdVO){
      this.currSubOrderId = item.id || '';
      this.printType = printType || '0'
      this.isPrintAll = isPrintAll
      this.orderTypeQuery = item.orderType
      this.orderStatusQuery = item.orderStatus
      this.filterRow = filterRow || {}
      this.subOrderIdVO = subOrderIdVO || []
      if(item.isFreeShippingCn){
        this.$toast('到付订单不支持该模式，请进入订单详情使用原有发货模式')
        return
      }
      console.log('item',item)
      this.form.reciveName = item.receiverName || '';
      this.form.reciveMobile = item.receiverPhone || '';
      this.form.reciveAddress = item.receiverAddress || '';
      http({
        url: 'order/shipping/address/deafault',
        parmes:{
          "branchRemarkType": this.filterRow.branchRemarkType,
          "deliveryType": this.deliveryType[this.printType],
          "oneKey": this.isPrintAll,
          "orderStatusQuery": this.orderStatusQuery,
          "orderTypeQuery": this.orderTypeQuery,
          "searchKey": this.filterRow.searchKey
        },
        method: "post"
      })
      .then(rps => {
        if (rps.code === 200) {
          for (const key in rps.data) {
            this.form[key] = rps.data[key];
          }
          this.areaName = this.form.provinceName + '/' + this.form.cityName + '/' + this.form.areaName;
          this.printVisble = true;
        }
      }).catch(rps=>{

      });
    },
    checkInputFun(){
      let str=this.form.shipperName.replace(/\s+/g,"");
      if (!str) {
        this.$toast('寄件人不能为空');
        return
      }
      if (str && str.length > 20) {
        this.$toast('寄件人不能超过20个字');
        return
      }
      let reg = /^1\d{10}$|^0\d{2,3}-?\d{7,8}$/;
      if (!reg.test(this.form.shipperMobile)) {
        this.$toast('请输入正确的手机号或固话号');
        return
      }
      if (!this.form.provinceId || !this.form.cityId || !this.form.areaId) {
        this.$toast('省市区选项不能为空');
        return
      }
      let str2 = this.form.addressDetail.replace(/^\s+|\s+$/g,"");
      if (!str2) {
        this.$toast('寄送地址不能为空');
        return
      }
      if(this.printType != '2'){
        this.doSubmit()
      }else{
        if(this.form.enablePrintCount === 0 ){
          this.$toast('没有可打印订单')
        }else{
          this.doOrder()
        }
      }
    },
    doSubmit(){
      this.loading = true;
      console.log('this.subOrderIdVO',this.subOrderIdVO)
      let str=this.form.shipperName.replace(/\s+/g,"");
      let str2 = this.form.addressDetail.replace(/^\s+|\s+$/g,"");
      let parmes = {
        "provinceId": this.form.provinceId,
        "provinceName": this.form.provinceName,
        "areaId": this.form.areaId,
        "areaName": this.form.areaName,
        "cityId": this.form.cityId,
        "cityName": this.form.cityName,
        "deliveryAddress": str2,
        "deliveryPhone": this.form.shipperMobile,
        "deliveryUser": str,
        "subOrderId": this.subOrderIdVO.length == 0 ? this.currSubOrderId || '' : undefined,
        "printType":this.printType, // 打印类型: 0-快递码 1-自主打印 2-拣货单
        "subOrderIdList":this.subOrderIdVO.length > 0 ? this.subOrderIdVO : undefined
      }
      http({
        url: this.subOrderIdVO.length == 0 ? 'order/admin/systemDelivery' :'order/admin/systemDeliveryMerge',
        method: "POST",
        parmes:parmes
      }).then(rps => {
        if (rps.code === 200 && rps.data) {
          this.$toast(rps.message || '成功');
          this.loading = false;
          this.printVisble = false;
          this.$emit('callbackFun', this.currSubOrderId);
        }
      }).catch(rps=>{
        this.printVisble = false;
        this.loading = false
      });
    },
    onConfirm(val) {
      if (val && val.length > 0) {
        this.form.provinceId = val[0].code;
        this.form.provinceName = val[0].name;
        this.form.cityId = val[1].code;
        this.form.cityName = val[1].name;
        this.form.areaId = val[2].code;
        this.form.areaName = val[2].name;
        this.areaName = val[0].name + "/" + val[1].name + "/" + val[2].name;
        this.showArea = false;
      }
    },
    doOrder(){
      this.loading = true;
      let str=this.form.shipperName.replace(/\s+/g,"");
      let str2 = this.form.addressDetail.replace(/^\s+|\s+$/g,"");
      http({
        url: 'order/admin/pickingList/delivery',
        method: "POST",
        parmes:{
          "systemDeliveryParam": {
            "provinceId": this.form.provinceId,
            "provinceName": this.form.provinceName,
            "areaId": this.form.areaId,
            "areaName": this.form.areaName,
            "cityId": this.form.cityId,
            "cityName": this.form.cityName,
            "deliveryAddress": str2,
            "deliveryPhone": this.form.shipperMobile,
            "deliveryUser": str,
            "subOrderId": this.currSubOrderId || '',
          },
          "orderQueryParam": {
            "branchRemarkType": this.filterRow.branchRemarkType,
            "deliveryType": this.deliveryType[this.printType],
            "endTime": this.filterRow.endTime,
            "oneKey": this.isPrintAll,
            "orderStatusQuery": this.orderStatusQuery,
            "orderTypeQuery": this.orderTypeQuery,
            "searchKey": this.filterRow.searchKey,
            "startTime": this.filterRow.startTime
          },
          "isPrintAll": this.isPrintAll, //是否一键打印 0-否 1-是
          "subOrderId": this.currSubOrderId || '',
        }
      }).then(rps => {
        if (rps.code === 200 && rps.data) {
          this.$toast(rps.message || '成功');
          this.loading = false;
          this.printVisble = false;
          this.$emit('callbackFun', this.currSubOrderId);
        }
      }).catch(rps=>{
        this.printVisble = false;
        this.loading = false
      });
    }
  },
  created() {
  },
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
.printModle{
  background:#ffffff;
  padding-top: 50px;
  padding-left: 30px;
  padding-right: 30px;
  
  .info{
    font-size: 28px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    img{
      width: 40px;
      height: 40px;
    }
  }
  // .mt10{
  //   margin-bottom: 10px;
  // }
  .d1{
    /deep/.van-field__control{
      width:360px;
      height:50px;
      padding-left: 20px;
      color: #333333;
    }
    .icon{
      position: relative;
    }
    .hed_piao{
      position: relative;
      .piao{
        position:absolute;
        z-index: 1;
        right: 0;
        top:0;
        margin-top: 31px;
        margin-right: 15px;
      }
    }
  }
  .heg{
    border: 1PX solid #D8D8D8 ;
    margin-top: 20px;
    margin-bottom: 40px;
    margin-left: -39px;
    margin-right: -36px;
  }
 /deep/.van-cell{
    padding: 25px 30px !important;
  }
  // .van-cell::after {
  //   border-bottom: 0;
  // }
  /deep/.van-field__label{
    font-size: 26px;
    color: #999999;
  }
  .d2{
    background: #F2F2F2;
    border-radius: 20px;
    display: flex;
    align-items: flex-start;
    .recive-img{
      width: 80px;
      height: 80px;
      padding-top: 50px;
      padding-left: 40px;
      padding-bottom: 63px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .recive-message{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 20px;
      padding-top: 40px;
      padding-bottom: 40px;
      .recive-phone{
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
      }
      .recive-address{
        margin-top: 10px;
        font-size: 24px;
        color: #999;
      }
    }
    /deep/.van-field__label{
      color: #999999;
    }
    /deep/.van-field__control{
      width:340px;
      height:50px;
      padding-left: 20px;
      color: #333333;
    }
  }
  .d3{
    position: relative;
    /deep/.van-field__control{
      height:50px;
      padding-left: 20px;
      color: #333333;
    }
    /deep/.van-field__control{
      font-size: 36px;
      font-weight: 500;
      color: #ED3939;
      text-align: right;
      padding-right: 25px;
    }
    .dan{
      font-size: 24px;
      color: #333333;
      position: absolute;
      z-index: 1;
      right: 0;
      bottom: 0;
      margin-bottom: 10px;
    }
  }
  .d3-1{
    /deep/.van-field__label{
      width:340px;
    }
  }
  .d3-2{
    /deep/.van-field__label{
      width:360px;
    }
  }
}
.printFooter{
  width:100%;
  background:#ffffff;
  font-size: 28px;
  margin-top: 60px;
  padding-bottom: 60px;
  .d0{
    text-align: center;
    clear: both;
    width: 100%;
    display:-webkit-flex;
    display:flex;
    -webkit-justify-content:center;
  	justify-content:center;
    align-items: center;
    .d1{
      color: #333333;
      border-right: 1PX solid #D8D8D8;
      width: 50%;
      border-bottom-left-radius:10px;
    }
    .d2{
      padding:15px 118px 15px 117px ;
      background-color: var(--epButtonColor);
      color: var(--epTextColor);
      border-radius: 38px;
      /deep/.van-button--default {
        border: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        color: #000000;
        background-color:var(--epButtonColor);
        color: var(--epTextColor);
        vertical-align: middle;
      
      }
    }
  }
}
</style>
